import React from 'react';
import PropTypes from 'prop-types';
import MobileDetect from 'mobile-detect';

import debounce from 'lodash/debounce';
import { BREAKPOINT_MD, BREAKPOINT_SM } from '../constants';
import { inject, observer } from 'mobx-react';

class ResponsiveController extends React.Component {
  static propTypes = {
    envStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const mobileDetectInstance = new MobileDetect(window.navigator.userAgent);
    const isMobile = !!mobileDetectInstance.mobile();
    if (isMobile) {
      this.props.envStore.setUserAgentType('mobile');
      document.body.classList.add('_mobile');
    } else {
      this.props.envStore.setUserAgentType('desktop');
      document.body.classList.add('_desktop');
    }

    this.update();
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  resizeHandler = debounce(() => {
    this.update();
  }, 200);

  update() {
    this.windowWidth = window.innerWidth;
    const { envStore } = this.props;
    if (this.windowWidth > BREAKPOINT_MD) {
      envStore.setScreen('desktop');
    } else if (this.windowWidth <= BREAKPOINT_MD && this.windowWidth > BREAKPOINT_SM) {
      envStore.setScreen('tablet');
    } else {
      envStore.setScreen('mobile');
    }
  }

  render() {
    return this.props.children;
  }
}

export default inject(stores => ({ envStore: stores.store.envStore }))(observer(ResponsiveController));



// WEBPACK FOOTER //
// ./src/utils/responsive-controller.js